import { PrintPage } from "../../../components/PrintPage";
import { Main, Content } from "../../../components/Layout";
import useWrapper from "../../../hooks/useWrapper";
import { Col, Row } from "react-bootstrap";
import Slct from "../../../components/Slct";
import { useState, useEffect } from "react";
import getCommercial from "../../../util/getCommercial";
import usePaymentSlip from "../../../hooks/api/usePaymentSlip";
import TableResponsive from "../../../components/TableResponsive";
import api from "../../../services/api";
import useFormat from "../../../hooks/utils/useFormat";
import StatusFlag from "../../../components/StatusFlag";
import Loading from "../../../components/Loading";

export default function ReportsAdditionalItems() {
  const { config, me } = useWrapper();
  const { data: paymentSlips2, setquery: setpaymentSlipQuery } = usePaymentSlip({ is_trainee: false });
  const { formatReal, uniqObject } = useFormat();

  const _filter_init = {
    "Tipo de Relatório": "Produto",
    Turma: null,
  };
  const [filter, setfilter] = useState(_filter_init);

  const [commercials, setcommercials] = useState();
  useEffect(() => {
    (async function () {
      const _commercials = await getCommercial(null, null, "?paginate=false");
      setcommercials(_commercials);
    })();
  }, []);

  const [loading, setloading] = useState();

  const [contrateds, setcontrateds] = useState();
  const filterTurma = filter["Turma"];
  useEffect(() => {
    (async function () {
      if (filterTurma) {
        setloading(true);
        setpaymentSlipQuery(`?commercial_id=${filterTurma}&paginate=false&!custom_payment_id=null`);
        const _contracted_items = await api.get(
          `custom-payment?commercial_id=${filterTurma}&paginate=false&payer_type=item_adicional`,
          config,
        );
        setcontrateds(_contracted_items);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- `config` is a new object on every WrapperProvider render; including it would refetch on unrelated re-renders instead of only when the selected Turma changes.
  }, [filterTurma, setpaymentSlipQuery]);

  const [products, setproducts] = useState();
  useEffect(() => {
    if (paymentSlips2) {
      const _payments = paymentSlips2?.data?.filter(__paymentSlip => __paymentSlip.payment_for === "Produto");
      const _products = _payments.map(__payment => ({
        value: __payment.custom_payment?.id,
        label: __payment.custom_payment?.name,
      }));

      const _products_uniq = uniqObject({
        array: _products,
        key: "value",
      });
      setproducts([{ value: null, label: "-- Todos --" }, ..._products_uniq]);
      setloading(false);
    }
  }, [paymentSlips2, uniqObject]);

  useEffect(() => {
    paymentSlips2 && console.log("paymentSlips2", paymentSlips2);
  }, [paymentSlips2]);

  useEffect(() => {
    contrateds && console.log("contrateds", contrateds);
  }, [contrateds]);

  return (
    <PrintPage has_logo={true} signed_by={me.username}>
      <Main>
        <Content>
          <Row>
            <Col sm={3}>
              <label>Tipo de Resultados</label>
              <Slct
                value={filter?.["Tipo de Relatório"]}
                options={[
                  { value: "Produto", label: "Produtos" },
                  { value: "Cobrança", label: "Cobranças" },
                  { value: "Contratado", label: "Contratados" },
                ]}
                onChange={__ev => {
                  setfilter({
                    ...filter,
                    "Tipo de Relatório": __ev.value,
                  });
                }}
              />
            </Col>
            <Col sm={4}>
              <label>Turma</label>
              <Slct
                placeholder="..."
                value={filter["Turma"]}
                options={commercials || []}
                onChange={__ev => {
                  setfilter({
                    ...filter,
                    Turma: __ev.value,
                    Produto: null,
                  });
                }}
              />
            </Col>
            {filter?.["Tipo de Relatório"] === "Produto" && (
              <Col sm={3}>
                <label>Produto</label>
                <Slct
                  placeholder="..."
                  value={filter["Produto"]}
                  options={products || []}
                  onChange={__ev => {
                    setfilter({
                      ...filter,
                      Produto: __ev.value,
                    });
                  }}
                />
              </Col>
            )}
          </Row>
          <Row className="mt-4">
            {!loading ? (
              <Col>
                {(filter?.["Tipo de Relatório"] === "Produto" || filter?.["Tipo de Relatório"] === "Cobrança") && (
                  <TableResponsive
                    table={{
                      head: [
                        { data: "Item" },
                        { data: "Formando" },
                        { data: "Valor Unidade" },
                        { data: "Quantidade" },
                        { data: "Taxa de Transação" },
                        { data: "" },
                      ],
                      body:
                        paymentSlips2?.data
                          ?.filter(__paymentSlip => __paymentSlip.payment_for === filter?.["Tipo de Relatório"])
                          ?.filter(__paymentSlip => {
                            if (!!filter["Produto"] && filter?.["Tipo de Relatório"] === "Produto") {
                              if (__paymentSlip.custom_payment?.id !== filter["Produto"]) {
                                return false;
                              }
                            }
                            return true;
                          })
                          ?.map(__paymentSlip => ({
                            data: [
                              { element: __paymentSlip?.custom_payment?.name || "(Sem Nome)" },
                              { element: __paymentSlip?.trainee?.name },
                              { element: formatReal(__paymentSlip?.custom_payment?.value) },
                              { element: __paymentSlip?.custom_payment?.quantity || 0 },
                              { element: formatReal(__paymentSlip?.custom_payment?.convenience_fee) },
                              {
                                element: (
                                  <div className="text-end">
                                    <StatusFlag
                                      status={!!__paymentSlip?.value_paid ? "Pago" : "Aguardando Pagamento"}
                                    />
                                  </div>
                                ),
                              },
                            ],
                          })) || [],
                    }}
                  />
                )}
                {filter?.["Tipo de Relatório"] === "Contratado" && (
                  <TableResponsive
                    table={{
                      head: [
                        { data: "Item" },
                        { data: "Formando" },
                        { data: "Valor Unidade" },
                        { data: "Quantidade" },
                        { data: "Taxa de Transação" },
                      ],
                      body:
                        contrateds?.data?.map(__paymentSlip => ({
                          data: [
                            { element: __paymentSlip?.name || "(Sem Nome)" },
                            { element: __paymentSlip?.trainee?.name },
                            { element: formatReal(__paymentSlip?.value) },
                            { element: __paymentSlip?.quantity || 0 },
                            { element: formatReal(__paymentSlip?.convenience_fee) },
                          ],
                        })) || [],
                    }}
                  />
                )}
              </Col>
            ) : (
              <Col>
                <Loading />
              </Col>
            )}
          </Row>
        </Content>
      </Main>
    </PrintPage>
  );
}
